import TablePage from '@/found/components/table_page';
import { ProcessLog } from '@/found/modules';
import request from '@/found/utils/request';
import Form from './form/index';

export default {
  name: 'deliver_config',
  extends: TablePage,
  data() {
    return {};
  },
  components: {
    Form,
    ProcessLog,
  },
  created() {
    this.getConfigList('deliver_config_list');
  },
  methods: {

    modalClick({ val, row }) {
      let urls = '';
      let text = '';
      console.log(val);
      if (val.code === 'add') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name;
        this.openFull();
      }
      if (val.code === 'enable') {
        urls = '/mdm/orderPermission/enable';
        text = '启用';
        if (!this.selection.length) {
          this.$message.error('请选择要启用的行');
          return false;
        }
        this.operationClick(urls, text);
      }
      if (val.code === 'disable') {
        urls = '/mdm/orderPermission/disable';
        text = '禁用';
        if (!this.selection.length) {
          this.$message.error('请选择要禁用的行');
          return false;
        }
        this.operationClick(urls, text);
      }
      if (val.code === 'batch_deletion') {
        if (!this.selection.length) {
          this.$message.error('请选择要删除的行');
          return false;
        }
        this.$confirm('确定要删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          request.post('/mdm/orderPermission/delete', this.selection)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '删除成功',
                });
                this.getList();
              }
            });
        });
      }
    },
    operationClick(urls, text) {
      let datas = [];
      if (this.selection.length > 0) {
        datas = this.selection;
        request.post(urls, datas).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: `${text}成功`,
            });
            this.selection = [];
            this.getList();
          }
        });
      } else {
        this.$message({
          type: 'error',
          message: '请选择数据',
        });
      }
    },
  },
};
